import React from 'react';
import { motion } from 'framer-motion';

export default function PageHeader({ title, subtitle, children, gradient = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      style={{ marginBottom: '24px' }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h1 style={{
            margin: 0,
            fontSize: '20px',
            fontWeight: 700,
            color: gradient ? undefined : '#E8EAF0',
            lineHeight: 1.2,
            ...(gradient ? {
              background: 'linear-gradient(135deg, #E8EAF0 0%, #9BA3B8 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            } : {}),
          }}>
            {title}
          </h1>
          {subtitle && (
            <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#4A5270' }}>{subtitle}</p>
          )}
        </div>
        {children && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {children}
          </div>
        )}
      </div>
    </motion.div>
  );
}
